import { RepairsActions } from "../action-types/repairsActionType";

export const getRepairsList = (payload) => {
  return {
    type: RepairsActions.GET_REPAIRS_LIST,
    payload,
  };
};

export const setRepairsList = (payload) => {
  return {
    type: RepairsActions.SET_REPAIRS_LIST,
    payload,
  };
};
export const setRepairsPaginationList = (payload) => {
  return {
    type: RepairsActions.SET_REPAIRS_LIST_PAGINATION,
    payload,
  };
};

export const getRepairDefectsDetailsByIdList = (payload) => {
  return {
    type: RepairsActions.GET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST,
    payload,
  };
};

export const setRepairDefectsDetailsByIdList = (payload) => {
  return {
    type: RepairsActions.SET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST,
    payload,
  };
};